export default __webpack_public_path__ + "static/media/Gui.a5096586.jpeg";